import { useSearchParams } from 'react-router';

import type { LetterType } from '@/apps/engagement-letter-database/data/types';
import { useEngagementRecords, useWaiverRecords } from '@/apps/engagement-letter-database/store';

import DashboardDataGrid from './components/DashboardDataGrid';
import HeaderPane from './components/HeaderPane';

function HomeDashboard() {
  const [searchParams] = useSearchParams();
  const letterType = (searchParams.get('letterType') as LetterType) || 'engagement';

  useEngagementRecords();
  useWaiverRecords({ enabled: letterType === 'waiver' });

  return (
    <>
      <HeaderPane />
      <DashboardDataGrid letterType={letterType} />
    </>
  );
}

export default HomeDashboard;
